<template>
  <div id="app">
    <keep-alive :exclude="exclude">
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  data () {
    return {
      exclude: ['login', 'checkInfo']
    }
  }
}
</script>
<style lang="less">
#app {
  width: 100%; min-height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>
